module.exports = __webpack_public_path__ + "static/media/EmployeeIcon.7d385ae3.svg";